<template>
  <dropdown-menu ref="dropdownMenu" class="header-search__by">
    <svg
      slot="dropdown-menu__button"
      :class="searchBy.class"
      class="header-search__by-icon"
      width="22"
      height="22"
    >
      <use v-bind:xlink:href="searchBy.href" />
    </svg>
    <template slot="dropdown-menu__list">
      <label
        v-for="(item, key) in items"
        :key="key"
        class="header-search__by-option"
        :class="{ _active: key === value }"
      >
        <input
          v-model="value"
          :value="key"
          name="search-by"
          type="radio"
          @click="onItemClick"
        />
        <svg width="24" height="24">
          <use :xlink:href="item.href" />
        </svg>
        <span>{{ item.label }}</span>
      </label>
    </template>
  </dropdown-menu>
</template>

<script>
import DropdownMenu from '@@/shared/DropdownMenu';

const searchByData = {
  designation: {
    href: '#document_without-text',
    label: 'По наименованию'
  },
  text: {
    href: '#document',
    label: 'По наименованию и тексту'
  }
};

export default {
  components: {
    DropdownMenu
  },
  props: {
    defaultValue: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      value: this.defaultValue,
      items: searchByData
    };
  },
  computed: {
    searchBy() {
      return searchByData[this.value];
    }
  },
  methods: {
    onItemClick(e) {
      this.setValue(e.target.value);
      this.$emit('change', this.value);
      this.$refs.dropdownMenu.close();
    },
    setValue(value) {
      this.value = value;
    }
  }
};
</script>
